import React from 'react';
import styled from 'styled-components'
import { RoundedButton } from './RoundedButton';
import plusOnePeople from '../img/plus_one_people.svg';
import SVG from 'react-inlinesvg';

const DonateHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const DonateHeaderTitle = styled.div`
  font-size: 15px;
  font-weight: 300;
  flex: 1;
  text-align: center;
  line-height: 19px;
  font-weight: 400;
  margin-bottom: 30px;
  font-family: 'Mabry Pro', serif;
  color: #333;
`

const DonateHeaderImg = styled.div`
  width: 100px;
  color: #D75138;
  margin-bottom: 28px;
`

const DonateContainer = styled.div`
  border-radius: 5px;
  padding: 24px 23px 27px 23px;
  width: 100%;
  min-height: 211px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  border-radius: 30px;
`

const DonateButtonWrapper = styled(RoundedButton)`
  background-color: #D1462E;
  border-radius: 20px;
  color: white;
  border: none;
  font-family: 'Mabry Pro', serif;
  font-weight: 500;
  line-height: 18px;
  font-size: 18px;
  text-align: center;
  width: auto;
  padding: 10px 40px 12px 41px;
  margin: auto;
  box-shadow: none;
`

export const DonateButton = ({handleClick}) => {
  return (
    <DonateContainer>
      <DonateHeader>
        <DonateHeaderImg><SVG src={plusOnePeople} /></DonateHeaderImg>
        <DonateHeaderTitle>
          Поддержите работу фонда с помощью системы пожертвований +1ЛЮДИ
        </DonateHeaderTitle>
      </DonateHeader>
      <DonateButtonWrapper handleClick={handleClick}>Поддержать</DonateButtonWrapper>
    </DonateContainer>
  )
}
